import React from 'react';
import pluralize from 'pluralize';

import type { Memory } from '../../types/memory';

const MemoryStats: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <div className="memory-stats wa-cluster">
      <div className="wa-cluster wa-gap-xs">
        <i className="fa-light fa-eye" />
        <strong>{memory.views_count}</strong> {pluralize('view', memory.views_count)}
      </div>
      <div className="wa-cluster wa-gap-xs">
        <i className="fa-light fa-arrow-up-from-bracket" />
        <strong>{memory.shares_count}</strong> {pluralize('share', memory.shares_count)}
      </div>
      {/* <div className="wa-cluster wa-gap-xs">
        <i className="fa-light fa-envelope" />
        <strong>{memory.email_opens_count}</strong> {pluralize('email open', memory.email_opens_count)}
      </div> */}
    </div>
  );
}

export default MemoryStats;
